import { ApiResource } from '@/core/models/ApiResource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { UnifiedPostRequest } from './unified-post-request.interface';
import { UnifiedPostRequestService } from './unified-post-request.service';

const service = new UnifiedPostRequestService();

export interface UnifiedPostRequestState {
   unifiedPostRequestsOverview?: ApiResource<Array<UnifiedPostRequest>>;
}

const UnifiedPostRequestStore: Module<UnifiedPostRequestState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_UNIFIED_POST_REQUEST_OVERVIEW(state, overview: ApiResource<Array<UnifiedPostRequest>>) {
         state.unifiedPostRequestsOverview = overview;
      },
   },
   actions: {
      async getUnifiedPostRequests(context, query?: LocationQuery) {
         const response = await service.getUnifiedPostRequests(query);
         context.commit('SET_UNIFIED_POST_REQUEST_OVERVIEW', response);
         return response.data;
      },
   },
};

export default UnifiedPostRequestStore;
